// src/com/plan_pos/TransPlanPosView.js
import React from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle, AppWord, MapValue } from '../../value/AppConst';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { LabelCell, ViewerCloserBox } from '../../common/TopStyle';
import { mapRequestRepo } from '../../value/AppModel';

const DetailBox = styled(Box)({
    marginTop: '0.5rem', paddingBottom: '0.5rem',
    borderBottom: '1px solid #ccc',
    //borderRadius: '0.5rem',
    backgroundColor: '#fff',
});

const DetailHeader = styled(Box)({
    backgroundColor: '#eee', color: AppStyle.PrimaryRGB, // padding: '0.5rem',
    border: '1px solid #ddd', padding: '0.5rem',
    borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
});

/**
 * 차량관제 상세정보.
 */
export default function TransPlanPosView({
    item,
    onClose,
}) {

    const onClickGoToMap = () => {
            // set mapRequestRepo data
            const mapData = {
                job: MapValue.Job.ShowTruck,
                info: {
                    vehPlates: item.vehPlates,
                    driverName: item.driverName,
                    gpsTime: item.gpsTime,
                    lat: item.lat,
                    lon: item.lon,
                    location: item.location,
                    posSys: item.posSys,
                    direction: item.direction,
                    speed: item.speed,
                }
            };
            mapRequestRepo({data: mapData});
        };

    const hasLocation = item.gpsTime && item.lat >= MapValue.Korea.South && item.lon >= MapValue.Korea.West;
    return(
        <DetailBox>
            <DetailHeader>
                <span>{item.dcName}</span>
                <span style={{marginLeft: '1rem', marginRight: '1rem'}}>...</span>
                <span>{item.storeName}</span>
            </DetailHeader>
            <TableContainer component={Paper}>
                <Table size={AppWord.SMALL}>
                    <TableBody>
                        <TableRow>
                            <LabelCell>출발지</LabelCell>
                            <TableCell>{item.dcName}</TableCell>
                            <LabelCell>도착지</LabelCell>
                            <TableCell>{item.storeName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>호차</LabelCell>
                            <TableCell>{item.hocha}</TableCell>
                            <LabelCell>차량번호</LabelCell>
                            <TableCell>{item.vehPlates}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>최종일시</LabelCell>
                            <TableCell colSpan={3}>
                                {
                                    hasLocation
                                    ?
                                    <span>
                                        {item.gpsTime}
                                        <Button
                                            variant={AppStyle.mui.contained}
                                            size={AppWord.SMALL}
                                            style={{marginLeft: '0.5rem'}}
                                            startIcon={<LocationOnIcon />}
                                            onClick={onClickGoToMap}
                                        >
                                            지도
                                        </Button>
                                    </span>
                                    :
                                    <span>[위치 없음]</span>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>최종위치</LabelCell>
                            <TableCell colSpan={3}>
                                {hasLocation ? item.location : '[위치 없음]'}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>운송사</LabelCell>
                            <TableCell colSpan={3}>{item.comName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>기사명</LabelCell>
                            <TableCell>{item.driverName}</TableCell>
                            <LabelCell>기사전화</LabelCell>
                            <TableCell>
                                {
                                    item.driverMobile && item.driverMobile.length > 9 ?
                                    <a href={`tel:${item.driverMobile}`}>
                                    {item.driverMobile}
                                    </a>
                                    : '(없음)'
                                }
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <ViewerCloserBox onClick={onClose} />
        </DetailBox>
    );
}
